import { Injectable } from '@angular/core';
import { LegalDocumentsProvider } from '@app/core/legal-documents/legal-document-provider';
import { LegalDocumentsFacade } from '@app/core/legal-documents/legal-documents.facade';

@Injectable({
  providedIn: 'root',
})
export class TermsFacade extends LegalDocumentsFacade implements LegalDocumentsProvider {
  public readonly data$ = this.getTerms();

}
